
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24"
  },
  "children": [
    {
      "tag": "defs",
      "children": [
        {
          "tag": "clipPath",
          "attrsMap": {
            "id": "clip-path"
          },
          "children": [
            {
              "tag": "rect",
              "attrsMap": {
                "id": "矩形_11200",
                "data-name": "矩形 11200",
                "class": "cls-1",
                "width": "24",
                "height": "24",
                "transform": "translate(0 -0.412)"
              }
            }
          ]
        }
      ]
    },
    {
      "tag": "g",
      "attrsMap": {
        "id": "蒙版组_240",
        "data-name": "蒙版组 240",
        "class": "cls-2",
        "transform": "translate(0 0.412)"
      },
      "children": [
        {
          "tag": "path",
          "attrsMap": {
            "id": "chuifengji",
            "class": "cls-3",
            "d": "M4.955,0A5.214,5.214,0,0,1,6,.105l7.372.842A1.076,1.076,0,0,1,14.345,2V7.531a1.076,1.076,0,0,1-.974,1.051l-6.353.726L5.661,17.116A1.092,1.092,0,0,1,4.572,18H2.253a1.128,1.128,0,0,1-.8-.33,1.034,1.034,0,0,1-.3-.784L1.621,8.3A4.631,4.631,0,0,1,.315,3.053,4.971,4.971,0,0,1,4.955,0ZM2.661,8.993l-.38,7.392a.539.539,0,0,0,.525.555H4.1a.546.546,0,0,0,.546-.448l1.141-7.03a5.216,5.216,0,0,1-.83.066,5.124,5.124,0,0,1-2.293-.536ZM4.955,1.059A3.888,3.888,0,0,0,1.514,3.086a3.578,3.578,0,0,0,.32,3.859A3.945,3.945,0,0,0,5.565,8.425l.2-.035.115-.017,6.875-.8a.538.538,0,0,0,.486-.526V2.481a.538.538,0,0,0-.486-.526l-6.87-.8-.116-.017a4.049,4.049,0,0,0-.813-.082Zm15.01,3.884A2.178,2.178,0,0,1,21.93,6.169a.476.476,0,0,1-.214.643.519.519,0,0,1-.678-.184,1.164,1.164,0,0,0-2.153.011,2.185,2.185,0,0,1-3.917,0,.468.468,0,0,1-.018-.492.517.517,0,0,1,.885-.01l.011.02A1.165,1.165,0,0,0,18,6.169a2.178,2.178,0,0,1,1.965-1.226ZM4.955,3.176A1.624,1.624,0,0,1,6.612,4.765,1.624,1.624,0,0,1,4.955,6.353,1.624,1.624,0,0,1,3.3,4.765,1.624,1.624,0,0,1,4.955,3.176Zm0,1.059a.53.53,0,1,0,.552.529A.541.541,0,0,0,4.955,4.235ZM19.965,1.06A2.178,2.178,0,0,1,21.93,2.287a.476.476,0,0,1-.214.643.519.519,0,0,1-.678-.184,1.164,1.164,0,0,0-2.153.011,2.186,2.186,0,0,1-3.917,0,.474.474,0,0,1,.178-.657.52.52,0,0,1,.689.155l.011.02A1.165,1.165,0,0,0,18,2.287,2.178,2.178,0,0,1,19.965,1.06Z",
            "transform": "translate(1.017 2.588)"
          }
        }
      ]
    }
  ]
})
    }
  